import LocalizedStrings from "react-localization";

export default new LocalizedStrings({
    en: {
        navigateAwayUnsavedPrompt:
            "You have unsaved changes. Are you sure you want to navigate away from this page?",
        navigateAwayUnsavedCommentPrompt:
            "You have an unsaved comment. Are you sure you want to navigate away and discard it?",
        applyActionUnsavedPrompt: "You have unsaved changes. Are you sure you want to proceed?",
        userInactiveNotification: "You seem to be idle or away.",
        userInactiveNotificationDetail: "Dev mode executions halted.",
        authAccountActivateSuccessful: "Account activated successfully.",
        authAccountActivateFailed: "There was a problem activating your account.",
    },
});
